export default __webpack_public_path__ + "static/media/H1005.3.21dd0852.mp3";